module.exports = __webpack_public_path__ + "static/media/Slide1.3ff629e4.jpg";